
import {
  computed,
  defineComponent, Ref, ref, watch,
} from 'vue';
import { useRouter } from 'vue-router';
import { useDriveStore } from '../modules/drive/store/driveStore';
import { IError, IFolder } from '@/types/interfaces';
import { useMainStore } from '@/store/mainStore';
import DriveInput from '../modules/drive/components/UI/DriveInput.vue';
import DriveDesktopInput from '../modules/drive/components/UI/DriveDesktopInput.vue';
import AppSkeletonFolder from './skeletons/AppSkeletonFolder.vue';
import NotificationService from '@/services/NotificationService';

export default defineComponent({
  components: {
    DriveInput,
    DriveDesktopInput,
    AppSkeletonFolder,
  },
  setup() {
    const mainStore = useMainStore();
    const driveStore = useDriveStore();
    const router = useRouter();

    const loader: Ref<boolean> = ref(false);
    const folderName: Ref<string> = ref('');
    const error: Ref<string> = ref('');

    const disabled = computed(() => !!error.value || !folderName.value);

    function createFolder(): void {
      if (disabled.value) {
        return;
      }
      loader.value = true;

      driveStore.currentFolder = { name: folderName.value, id: driveStore.currentFolder?.id } as IFolder;

      driveStore.createFolder(folderName.value, driveStore.currentFolder.id)
        .then((response) => {
          router.push(`/drive/folder/${(response as IFolder).id}?hideSkeletons=true`).then(() => {
            loader.value = true;
            mainStore.closeCreateFolderPopUp();
            // NotificationService.notifySuccess();
          });
        }).catch((e) => {
          if (e?.response?.data?.errorKey === 'FOLDER_NAME_EXISTS') {
            error.value = 'Name is already taken';
          } else {
            error.value = 'Something gone wrong';
          }
          loader.value = false;
        });
    }

    function inFolderNameUniq(): boolean {
      if (!driveStore.currentFolder) {
        return false;
      }
      return !!driveStore.currentFolder?.mixedData?.find((folder) => folder?.folder?.name === folderName.value);
    }

    watch(() => folderName.value, () => {
      if (!folderName.value) {
        error.value = 'This filed is required';
      } else if (folderName.value.length < 1) {
        error.value = 'Folder name must be at least 1 character long.';
      } else if (folderName.value.length > 255) {
        error.value = 'Folder name must be max 255 characters long.';
      } else if (inFolderNameUniq()) {
        error.value = 'Name is already taken';
      } else {
        error.value = '';
      }
      folderName.value = folderName.value.replace(/(\r\n|\n|\r)/gm, '');
    });

    return {
      folderName,
      error,
      disabled,
      mainStore,
      driveStore,
      loader,
      createFolder,
    };
  },
});
